import * as React from "react"

/** React hook for isomorphic client-side rendering. */
export const useLayoutEffect =
  typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect
